import { useQuery, useMutation, useQueryClient } from 'react-query';
import { GetRoles, CreateRole, UpdateRole, DeleteRole } from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetRoles() {
    return useQuery(
        ['roles'], () => GetRoles(), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.roles || [];
        },
        onError: (error) => {
            NotifyError('Failed to fetch roles', error);
            console.error('Error fetching roles:', error);
        }
    });
}

export function useCreateRole() {
    const queryClient = useQueryClient();

    return useMutation(CreateRole, {
        onSuccess: () => {
            Notify('Role created successfully', 'success');
            queryClient.invalidateQueries('roles');
        },
        onError: (error) => {
            NotifyError('Failed to create role', error);
            console.error('Error creating role:', error);
        }
    });
}

export function useUpdateRole() {
    const queryClient = useQueryClient();

    return useMutation(({ roleId, data }) => UpdateRole(roleId, data), {
        onSuccess: () => {
            Notify('Role updated successfully', 'success');
            queryClient.invalidateQueries('roles');
        },
        onError: (error) => {
            NotifyError('Failed to update role', error);
            console.error('Error updating role:', error);
        }
    });
}

export function useDeleteRole() {
    const queryClient = useQueryClient();

    return useMutation(DeleteRole, {
        onSuccess: () => {
            Notify('Role deleted successfully', 'success');
            queryClient.invalidateQueries('roles');
        },
        onError: (error) => {
            NotifyError('Failed to delete role', error);
            console.error('Error deleting role:', error);
        }
    });
}
